import React from 'react'
import { useDispatch } from 'react-redux'
import { IconBurgerCollapse, IconBurgerExpand } from '../icons'
import styled from 'styled-components'

const Toggler = styled.button`
	/* background-color: rgba(50, 160, 229, 0.20); */
	background-color: #103751;
	/* aspect-ratio: 1 / 1; */
	width: 32px;
	height: 32px;
	display: inline-flex;
	justify-content: center;
	align-items: center;
	padding: 4px;
	border-radius: 50%;
`

export const BurgerToggle = (props) => {
	const { collapsed } = props
	const dispatch = useDispatch()
	const collapsedNew = {
		type: 'SET_CONFIG_KEY',
		key: 'collapsed',
		value: !collapsed
	}

	return <>
		<Toggler onClick={() => dispatch(collapsedNew)}>
			{
				!collapsed
					? (<IconBurgerCollapse size={9} />)
					: (<IconBurgerExpand size={9} />)
			}
		</Toggler>
	</>
}
